import { indexEntries } from '@/mocks/home';

export default function QuickIndex() {
  return (
    <section id="index" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              今日黑料索引
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              按题材直达，明星黑料、网红黑料、爆料合集一处集合
            </p>
          </div>
          <a
            href="#rank"
            className="inline-flex w-fit cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            查看完整吃瓜榜单
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
          {indexEntries.map((item) => (
            <a
              key={item.id}
              href="#timeline"
              className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50 md:p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <span className="mt-4 font-heading text-base font-bold text-foreground-950">
                {item.title}
              </span>
              <span className="mt-1 text-xs leading-relaxed text-foreground-500">{item.desc}</span>
              <span className="mt-3 flex items-center gap-1 text-xs font-medium text-secondary-700">
                {item.count}
                <i className="ri-arrow-right-s-line transition-transform group-hover:translate-x-0.5"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}